// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusSquareTwoToneSvg from "@fishx/icons-svg/es/asn/PlusSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareTwoToneSvg
  }));
};

PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
export default React.forwardRef(PlusSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusSquareTwoTone.js
// module id = 3828
// module chunks = 0